import React from "react";
import { RulesProvider } from "./provider/RulesContext";
import DisplayRules from "./DisplayRules";
import { UserProvider } from "../Users/provider/UserContext";
const index = () => {
  return (
    <UserProvider>
      <RulesProvider>
        <DisplayRules />
      </RulesProvider>
    </UserProvider>
  );
};

export default index;
